export default __webpack_public_path__ + "static/media/arrow.74c9ac35.svg";